import { g as getFocusableElements } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/getFocusableElements-BjFtn5aB-BjFtn5aB.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';

// eslint-disable-next-line import/prefer-default-export
const handleKeyDownEvents = (event, context, escapeAction, selectAction) => {
  const {
    key
  } = event;
  if (context) {
    const focusableEls = getFocusableElements(context);
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    if (key === KEYBOARD_KEYNAMES.ARROW_DOWN || key === KEYBOARD_KEYNAMES.ARROW_UP || key === KEYBOARD_KEYNAMES.HOME || key === KEYBOARD_KEYNAMES.END) {
      const currentIndex = focusableEls.indexOf(document.activeElement);
      let newFocusIndex;
      if (key === KEYBOARD_KEYNAMES.ARROW_DOWN) {
        newFocusIndex = currentIndex + 1;
        if (document.activeElement === lastFocusableEl) {
          newFocusIndex = focusableEls.length - 1;
        }
      }
      if (key === KEYBOARD_KEYNAMES.ARROW_UP) {
        newFocusIndex = currentIndex - 1;
        if (document.activeElement === firstFocusableEl) {
          newFocusIndex = 0;
        }
      }
      if (key === KEYBOARD_KEYNAMES.HOME) {
        newFocusIndex = 0;
      }
      if (key === KEYBOARD_KEYNAMES.END) {
        newFocusIndex = focusableEls.length - 1;
      }
      if (typeof newFocusIndex !== 'undefined' && newFocusIndex >= 0) {
        focusableEls[newFocusIndex].focus();
        event.preventDefault();
        return focusableEls[newFocusIndex];
      }
    }
    if (key === KEYBOARD_KEYNAMES.ESCAPE) {
      escapeAction();
      event.preventDefault();
    }
    if (key === KEYBOARD_KEYNAMES.TAB) {
      // Prevent the tab event in dropdown
      event.preventDefault();
    }
    /**
     * The event target must have the role 'option'
     * in order to allow other interactable elements
     * within dropdowns
     */
    if ((key === KEYBOARD_KEYNAMES.ENTER || key === KEYBOARD_KEYNAMES.SPACE) && event.target instanceof HTMLElement && event.target.getAttribute('role') === 'option') {
      if (selectAction) {
        selectAction(event);
        event.preventDefault();
      }
    }
  }
  return null;
};
const getPlacement = position => {
  if (position === 'top') {
    return 'top-start';
  }
  return 'bottom-start';
};

export { getPlacement as g, handleKeyDownEvents as h };
//# sourceMappingURL=utils-BSiT3_dq.js.map
